// The Go API HTML-escapes passwords and concatenates them into JSON strings.
// Compatibility restrictions for langloys_api/api/models/Utilisateur.go.
export const FORBIDDEN_PASSWORD_CHARACTERS = ['&', '<', '>', '"', "'", '\\'];
export const PASSWORD_CHARACTER_CONSTRAINTS = `Caractères interdits : ${FORBIDDEN_PASSWORD_CHARACTERS.join(' ')}. Les espaces, tabulations, retours à la ligne et caractères de contrôle sont également interdits.`;

export const hasForbiddenPasswordCharacters = (value) =>
  // eslint-disable-next-line no-control-regex -- Explicitly reject controls before manually assembled backend JSON.
  /[\s\u0000-\u001f\u007f]/.test(value) ||
  FORBIDDEN_PASSWORD_CHARACTERS.some((character) => value.includes(character));

export const PASSWORD_RULES = [
  { id: 'length', label: '10 caractères minimum', test: (value) => Array.from(value).length >= 10 },
  { id: 'uppercase', label: 'Une lettre majuscule', test: (value) => /[A-Z]/.test(value) },
  { id: 'lowercase', label: 'Une lettre minuscule', test: (value) => /[a-z]/.test(value) },
  { id: 'digit', label: 'Un chiffre', test: (value) => /\d/.test(value) },
  { id: 'special', label: 'Un caractère spécial (ex. ! @ # $ %)', test: (value) =>
    Array.from(value).some((character) => /[\p{P}\p{S}]/u.test(character) && !hasForbiddenPasswordCharacters(character)) },
  { id: 'characters', label: `Aucun espace ni caractère interdit (${FORBIDDEN_PASSWORD_CHARACTERS.join(', ')})`, test: (value) => value.length > 0 && !hasForbiddenPasswordCharacters(value) },
];

export const getUnmetPasswordRules = (value) => PASSWORD_RULES.filter((rule) => !rule.test(value));
export const isValidNewPassword = (value) => getUnmetPasswordRules(value).length === 0;
